module.exports = __webpack_public_path__ + "img/saint_martin.e54f7dd.webp";